import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, Server, Database } from 'lucide-react';
import PageHeader from './ui/PageHeader';
import apiService from '../services/apiService';

const StatusRow = ({ ok, label, detail }) => (
  <div className="flex items-start justify-between gap-4 border-b border-white/10 py-3 last:border-0">
    <div className="flex items-center gap-2">
      {ok ? (
        <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-400" />
      ) : (
        <XCircle className="h-5 w-5 shrink-0 text-amber-400" />
      )}
      <span className="text-sm font-medium text-slate-200">{label}</span>
    </div>
    <span className="text-right text-sm text-slate-400">{detail}</span>
  </div>
);

const Integrations = () => {
  const [health, setHealth] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiService
      .fetchHealth()
      .then(setHealth)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="page-container">
      <PageHeader
        title="Entegrasyon durumu"
        description="Randevu ve çağrı kayıtları bu sunucuda tutulur."
      />

      {error && (
        <div className="mb-6 rounded-lg border border-rose-400/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-200">
          {error}
        </div>
      )}

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="card lg:col-span-2">
          <div className="mb-4 flex items-center gap-2">
            <Server className="h-5 w-5 text-accent-300" />
            <h3 className="font-semibold text-white">Bu sunucu (Modül 3)</h3>
          </div>
          {health ? (
            <>
              <StatusRow
                ok={health.storageDriver === 'postgres'}
                label="Veritabanı"
                detail={health.storageDriver || '—'}
              />
              <StatusRow
                ok={health.databaseConfigured}
                label="PostgreSQL bağlantısı"
                detail={health.databaseConfigured ? 'Yapılandırıldı' : 'Yok / JSON modu'}
              />
              <StatusRow
                ok={health.toolApiKeyConfigured}
                label="Araç API anahtarı"
                detail={health.toolApiKeyConfigured ? 'Aktif' : 'Kapalı (geliştirme)'}
              />
              <StatusRow
                ok={health.webhookSecretConfigured}
                label="Post-call webhook imzası"
                detail={health.webhookSecretConfigured ? 'Yapılandırıldı' : 'Dev modu'}
              />
              <StatusRow
                ok
                label="Kayıtlı çağrılar"
                detail={String(health.totalCalls ?? 0)}
              />
              <StatusRow
                ok
                label="Kayıtlı randevular"
                detail={String(health.totalAppointments ?? 0)}
              />
            </>
          ) : (
            <p className="text-sm text-slate-500">Yükleniyor…</p>
          )}
        </div>

        <div className="card lg:col-span-2">
          <div className="mb-4 flex items-center gap-2">
            <Database className="h-5 w-5 text-accent-300" />
            <h3 className="font-semibold text-white">CRM (gelecek — Modül 3 genişletme)</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrations;
